import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Autocomplete, Box, CircularProgress, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAdminApplications } from '../../../hooks/useAdminApplications';

export const ApplicationList = () => {
    const [selectedFolder, setSelectedFolder] = useState<string>('');
    const { data: applications = [], isFetched, isLoading } = useAdminApplications();
    const navigate = useNavigate();
    const folders = new Set(applications.map(({ folder }) => folder).sort());

    const getFilteredApplications = () => {
        let filtered;

        if (selectedFolder.length > 0) {
            filtered = applications.filter(({ folder }) => folder === selectedFolder);
        } else {
            filtered = applications;
        }

        return filtered.sort((a, b) => (a.folder < b.folder ? -1 : 1));
    };

    const handleSelectFolder = (_: React.SyntheticEvent<Element, Event>, value: string | null) => {
        setSelectedFolder(value || '');
    };

    const handleSelectedApplication = (id: string) => {
        navigate(`/admin/applications/${id}`);
    };

    return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 3, maxWidth: (theme) => theme.breakpoints.values.sm }}>
                    <Autocomplete
                        options={Array.from(folders) ?? []}
                        renderOption={(props: object, folder: string) => {
                            return (
                                <ListItem {...props}>
                                    <ListItemText primary={folder} />
                                </ListItem>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" label="Folder" />}
                        loading={isLoading}
                        onChange={handleSelectFolder}
                        value={selectedFolder}
                    />
                </Box>
                <Divider />
                <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {!isFetched && <CircularProgress />}
                    {isFetched && (
                        <List sx={{ width: '100%', height: '100%', overflowY: 'scroll', p: 0 }}>
                            {getFilteredApplications().map(({ _id, folder, name }) => {
                                return (
                                    <ListItemButton key={_id.toString()} divider={true} onClick={() => handleSelectedApplication(_id.toString())}>
                                        <ListItemText primary={`${name}`} secondary={`${folder}`} />
                                        <ListItemIcon>
                                            <NavigateNextIcon />
                                        </ListItemIcon>
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
